
  export default {
    mounted() {
      this.chartData = JSON.parse(this.el.dataset.chartData || "[]")
      this.currencySymbol = this.el.dataset.currencySymbol || "$"
      this.i18n = JSON.parse(this.el.dataset.i18n || "null") || window.I18n || {}
      this.smoothingMode = '7day'
      this.renderChart()

      // Listen for button clicks on the toggle
      const toggleContainer = document.getElementById('retail-trend-smoothing')
      if (toggleContainer) {
        toggleContainer.addEventListener('click', (e) => {
          const btn = e.target.closest('.smoothing-btn')
          if (!btn) return

          // Update active state
          toggleContainer.querySelectorAll('.smoothing-btn').forEach(b => {
            b.classList.remove('bg-white', 'text-text-primary', 'font-semibold', 'shadow-[0px_2px_8px_0px_rgba(14,8,84,0.12)]')
            b.classList.add('text-text-secondary', 'font-normal')
          })
          btn.classList.remove('text-text-secondary', 'font-normal')
          btn.classList.add('bg-white', 'text-text-primary', 'font-semibold', 'shadow-[0px_2px_8px_0px_rgba(14,8,84,0.12)]')

          this.smoothingMode = btn.dataset.value
          this.renderChart()
        })
      }
    },

    calculateMovingAverage(data, windowSize) {
      return data.map((_, index, arr) => {
        const start = Math.max(0, index - windowSize + 1)
        const window = arr.slice(start, index + 1)
        const sum = window.reduce((acc, val) => acc + val, 0)
        return Math.round(sum / window.length)
      })
    },

    renderChart() {
      const chartData = this.chartData
      const i18n = this.i18n
      const currencySymbol = this.currencySymbol
      const t = (key) => i18n[key] || key
      const salesLabel = `${t("Sales")} (${currencySymbol})`
      if (chartData.length === 0) {
        this.el.innerHTML = `<div class="flex items-center justify-center h-full text-text-muted">${t("No retail data available")}</div>`
        return
      }

      import("highcharts").then((Highcharts) => {
        const dates = chartData.map(d => d.date)
        const rawSales = chartData.map(d => d.sales || 0)
        const rawVisitors = chartData.map(d => d.visitors)

        let salesData, visitorsData
        switch (this.smoothingMode) {
          case 'daily':
            salesData = rawSales
            visitorsData = rawVisitors
            break
          case '28day':
            salesData = this.calculateMovingAverage(rawSales, 28)
            visitorsData = this.calculateMovingAverage(rawVisitors, 28)
            break
          case '7day':
          default:
            salesData = this.calculateMovingAverage(rawSales, 7)
            visitorsData = this.calculateMovingAverage(rawVisitors, 7)
            break
        }

        window.Enaia.applyHighchartsTheme(Highcharts.default)
        Highcharts.default.chart(this.el.id, {
          chart: {
            backgroundColor: 'transparent'
          },
          title: { text: null },
          xAxis: {
            categories: dates,
            labels: {
              rotation: -45,
              style: {
                fontSize: '10px',
                color: '#6B7280'
              },
              step: Math.ceil(dates.length / 10)
            }
          },
          yAxis: [{
            min: 0,
            title: {
              text: salesLabel,
              style: { fontSize: '12px' }
            }
          }, {
            min: 0,
            title: {
              text: t("Visitors"),
              style: { fontSize: '12px' }
            },
            opposite: true
          }],
          legend: {
            enabled: true,
            align: 'center',
            verticalAlign: 'bottom'
          },
          tooltip: {
            shared: true,
            useHTML: true,
            formatter: function() {
              const date = this.x
              const sales = this.points[0]?.y || 0
              const visitors = this.points[1]?.y || 0
              return `<div style="padding: 8px;">
                <strong>${date}</strong><br/>
                ${salesLabel}: ${currencySymbol}${sales.toLocaleString()}<br/>
                ${t("Visitors")}: ${visitors.toLocaleString()}
              </div>`
            }
          },
          plotOptions: {
            area: {
              fillColor: {
                linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
                stops: [
                  [0, 'rgba(20, 184, 166, 0.3)'],
                  [1, 'rgba(20, 184, 166, 0.05)']
                ]
              },
              lineWidth: 2,
              marker: { enabled: false }
            },
            line: {
              lineWidth: 2,
              marker: { enabled: false }
            }
          },
          series: [{
            name: salesLabel,
            type: 'area',
            data: salesData,
            color: '#0086e6',
            yAxis: 0
          }, {
            name: t("Visitors"),
            type: 'line',
            data: visitorsData,
            color: '#F97316',
            yAxis: 1
          }],
          credits: { enabled: false }
        })
      })
    }
  }
